module.exports = __webpack_public_path__ + "img/question.de9f5d12.gif";